import { getOnlineSalesRelation, getOnlineSalesLead, getCorpTagConfig } from '../api';
import { getSaleEmployeeList } from '@/pages/agency/manage/operation-log/api';
import { VisibilityScope, TagGroup, GetCustomerList, GetLeadList } from '../interface';

export const getCustomerList = (params: { data: GetCustomerList }) => {
  let { data: newParams } = params;
  const { addTimeBegin, addTimeEnd, hasRelatedLead, page = 0, page_size = 10, ...others } = newParams;
  newParams =  {
    ...others,
    pageIndex: (page - 1),
    pageSize: page_size,
    addTimeBegin: addTimeBegin ? `${addTimeBegin} 00:00:00` : undefined,
    addTimeEnd: addTimeEnd ? `${addTimeEnd} 23:59:59` : undefined,
    hasRelatedLead: hasRelatedLead || hasRelatedLead === 0 ? Boolean(hasRelatedLead) : undefined,
  };
  return getOnlineSalesRelation(newParams)
    .then((res: any) => {
      const { code, message, data: { items = [], conf: { totalCount = 0 } = {} } = {} } = res;
      return {
        code,
        msg: message,
        data: {
          list: items,
          conf: {
            total_num: totalCount,
          },
        },
      };
    })
    .catch(() => {
      return {
        data: {
          list: [],
          conf: {
            total_num: 0,
          },
        },
      };
    });
};

export const getLeadList = (params: { data: GetLeadList}) => {
  let { data: newParams } = params;
  const { page = 0, page_size = 10, leadId, ...others } = newParams;
  newParams =  {
    ...others,
    leadId: leadId ? Number(leadId) : undefined,
    pageIndex: (page - 1),
    pageSize: page_size,
    visibilityScope: VisibilityScope.private,
  };
  return getOnlineSalesLead(newParams)
    .then((res: any) => {
      const { code, message, data: { items = [], conf: { totalCount = 0 } = {} } = {} } = res;
      return {
        code,
        msg: message,
        data: {
          list: items,
          conf: {
            total_num: totalCount,
          },
        },
      };
    })
    .catch(() => {
      return {
        data: {
          list: [],
          conf: {
            total_num: 0,
          },
        },
      };
    });
};

export const getTagList = () => {
  return getCorpTagConfig().then((res: any) => {
    const { data = [] } = res;
    return data.map((v: TagGroup) => {
      const { groupId, groupName, tag = [] } = v;
      const tags = tag.map(({ id, name }) => ({ value: id, name, desc: name }));
      return { value: groupId, name: groupName, desc: groupName, options: tags };
    });
  });
};

export const searchEmployee = (keywords = '') => {
  return getSaleEmployeeList({
    data: {
      keywords,
      field: 'USER_NAME',
    },
  })
    .then((res) => {
      const { list = [] } = res;
      return list.map((v: any) => ({
        value: v.employeeId,
        desc: v.operationUserName || v.name || v.userId,
      }));
    })
    .catch(() => {
      return [];
    });
};
